module.exports = __webpack_public_path__ + "static/media/part-2.1058ceb1.jpg";